<script>
import ReportingIcon from '@/assets/icons/reports.svg';

export default {
  name: 'ReportingPageIntro',
  components: { ReportingIcon },
};
</script>

<template>
  <div class="reporting-page-intro">
    <div class="reporting-page-intro__icon">
      <ReportingIcon />
    </div>
    <h1 class="reporting-page-intro__title">
      {{ $t('ADVERTISEMENT.REPORTING.CAMPAIGNS_REPORTING') }}
    </h1>
    <div class="reporting-page-intro__description">
      {{ $t('ADVERTISEMENT.REPORTING.DESCRIPTION') }}
    </div>
    <div class="reporting-page-intro__help text-bold">
      {{ $t('ADVERTISEMENT.REPORTING.HELP') }}
    </div>
  </div>
</template>

<style lang="scss">
.reporting-page-intro {
  height: 450px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: auto;
  gap: 1.5rem;

  &__icon {
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border-radius: 50%;
    background-color: $lb-light-green;

    svg {
      vertical-align: middle;
    }
  }
}
</style>
